
import React, { createContext, useContext, ReactNode } from 'react';
import { useCentralizedSession } from '@/hooks/useCentralizedSession';
import { UserProfile } from '@/types/auth';

interface CentralizedAuthContextType {
  user: UserProfile | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  sessionToken: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const CentralizedAuthContext = createContext<CentralizedAuthContextType | undefined>(undefined);

interface CentralizedAuthProviderProps {
  children: ReactNode;
}

export const CentralizedAuthProvider = ({ children }: CentralizedAuthProviderProps) => {
  const sessionData = useCentralizedSession();

  return (
    <CentralizedAuthContext.Provider value={sessionData}>
      {children}
    </CentralizedAuthContext.Provider>
  );
};

export const useCentralizedAuth = (): CentralizedAuthContextType => {
  const context = useContext(CentralizedAuthContext);
  
  if (context === undefined) {
    throw new Error('useCentralizedAuth must be used within a CentralizedAuthProvider');
  }
  
  return context;
};
